module.exports = "<p>hc-meds works!</p>\n"